var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('froala',{attrs:{"id":"edit","tag":"textarea","config":_vm.config},model:{value:(_vm.content.content),callback:function ($$v) {_vm.$set(_vm.content, "content", $$v)},expression:"content.content"}}),_c('b-modal',{attrs:{"title":"Pick image"}},[_c('image-browser')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }